var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticClass: "create",
          attrs: { type: "primary" },
          on: { click: _vm.clickCreate }
        },
        [_vm._v(_vm._s(_vm.buttonCaption))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }